import HoldingReportRepository from "@adapters/repositories/Reports/HoldingReport";
import { downloadReportsRepo } from "../../understandingCommonDI/downloadReportsDI";
import DPTransactionReportRepository from "@adapters/repositories/Reports/DPTransactionReport";
import { accountDetails } from "@mainDi/webDi";
import { qouteStream } from "@mainDi/streamerDi";
import DashboardRepository from "@adapters/repositories/Reports/common/dashboardRepo";
export default (function (http, infrastructure) {
    return {
        holdingMainScreenRepo: new HoldingReportRepository(http, accountDetails),
        downloadRepo: downloadReportsRepo,
        quoteStream: qouteStream,
        dpTransactionRepo: new DPTransactionReportRepository(http, accountDetails),
        dashboardRepo: new DashboardRepository(http, accountDetails),
    };
});
